import { PortableTextReactComponents } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'
import styles from './GlobalNewsletterModal.module.scss'
import RichText from '@/components/RichText/RichText'

const portableTextSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <p className={styles.header}>{children}</p>,
  },
  marks: {
    redText: ({ text }) => {
      return <span className={styles.redText}>{text}</span>
    },
  },
}

interface HeaderProps {
  content: PortableTextBlock | PortableTextBlock[]
}

function Header({ content }: HeaderProps) {
  return (
    <RichText
      value={content}
      components={portableTextSerializer}
    />
  )
}

export default Header
